// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"1a3b09e1","315":"1a3b09e1"}[chunkId] + ".chunk.css";
};